import { useMutation } from "react-query";
import { addSecurity } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSecurity = () => {
  return useMutation(addSecurity);
};
export default useAddSecurity;
